import React, { useState, useEffect } from 'react';
import { Device } from '@twilio/voice-sdk';
import { Button, IconButton, Typography, Box, CircularProgress } from '@mui/material';
import CallIcon from '@mui/icons-material/Call';
import CallEndIcon from '@mui/icons-material/CallEnd';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import { styled } from '@mui/system';
import axios from 'axios';
import {url} from '../utils/config';
import { useNavigate } from 'react-router-dom';

const Container = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
  backgroundColor: '#f5f5f5',
});

const CallButton = styled(IconButton)({
  backgroundColor: '#4CAF50',
  color: '#fff',
  '&:hover': {
    backgroundColor: '#45a049',
  },
  margin: '10px',
});

const EndButton = styled(IconButton)({
  backgroundColor: '#f44336',
  color: '#fff',
  '&:hover': {
    backgroundColor: '#e53935',
  },
  margin: '10px',
});

const VoiceCall = ({outgoingCallerId, phone, setShowCallModal}) => {
  const [isCalling, setIsCalling] = useState(false);
  const [client, setClient] = useState(null);
  const [callStatus, setCallStatus] = useState('Disconnected');
  const [caller, setCaller] = useState(phone);
  const [call, setCall] = useState();
  const navigate = useNavigate()

  useEffect(() => {
    initializeTwilio();
    setTimeout(() => {makeCall()}, 100)
  }, []);

  const initializeTwilio = async () => {
    const { data } = await axios.post(url + '/voice_token', { outgoingCallerId })
    console.log(data);
    const newClient = new Device(data.token);

    newClient.on('incoming', (callData) => {
      // Handle incoming call
      setCaller(callData.parameters.From || 'Unknown Caller');
      setCallStatus('Incoming Call');
      setCall(callData)
    //   call.accept(); // Automatically accept incoming calls for this example
      setIsCalling(true);
    });

    newClient.on('connect', () => {
      setCallStatus('Connected');
    });

    newClient.on('disconnect', () => {
      setCallStatus('Disconnected');
      setIsCalling(false);
    });

    setClient(newClient);
    console.log(newClient)
  };

  const makeCall = () => {
    if (!client) return;

    const options = {
      params: {
        To: phone, // The phone number to call
        // From: outgoingCallerId
      },
    };

    try {
        client.connect(options);
        setCallStatus('Calling');
        setIsCalling(true);
    } catch (error) {
        console.log('some error')
        console.log(error.message)
        endCall()
    }
  };

  const endCall = () => {
    if (client) {
      client.disconnectAll();
      setCallStatus('Disconnected');
      setIsCalling(false);
      setShowCallModal(false)
    }
  };

  const acceptCall = () => {
    call.accept()
  } 

  return (
    <div className="flex w-screen h-screen fixed top-0 left-0 right-0 items-center justify-center bg-[#f5f5f5] z-50">
      <Container>
        <Typography variant="h4" gutterBottom>
          {callStatus}
        </Typography>
        {caller && (
          <Typography variant="h6" gutterBottom>
            {caller}
          </Typography>
        )}
        <Box display="flex" alignItems="center" justifyContent="center">
          {!isCalling ? (
            <CallButton onClick={makeCall}>
              <CallIcon />
            </CallButton>
          ) : (
            <EndButton onClick={endCall}>
              <CallEndIcon />
            </EndButton>
          )}
        </Box>
        {callStatus === 'Calling' && <CircularProgress />}
      </Container>
    </div>
  );
};

export default VoiceCall;
